/** The outcome of checking a password against each rule of the policy. */
export interface PasswordPolicyCheck {
  hasValidLength: boolean;
  hasUpperAndLowerCase: boolean;
  hasDigit: boolean;
  hasSpecialChar: boolean;
  /** Whether every rule is satisfied. */
  isValid: boolean;
}

/* Password policy — must stay the same as the backend's PasswordPolicyService. */
const PASSWORD_MIN_LENGTH = 8;
const UPPERCASE_PATTERN = /[A-Z]/;
const LOWERCASE_PATTERN = /[a-z]/;
const DIGIT_PATTERN = /\d/;
const SPECIAL_CHARACTER_PATTERN = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

/**
 * Checks a password against the policy. The single place the rules live, so every form that sets
 * a password enforces the same constraints.
 *
 * @param {string} password - The candidate password.
 * @returns {PasswordPolicyCheck} Which rules it satisfies.
 */
export function checkPasswordPolicy(password: string): PasswordPolicyCheck {
  const hasValidLength = password.length >= PASSWORD_MIN_LENGTH;
  const hasUpperAndLowerCase = UPPERCASE_PATTERN.test(password) && LOWERCASE_PATTERN.test(password);
  const hasDigit = DIGIT_PATTERN.test(password);
  const hasSpecialChar = SPECIAL_CHARACTER_PATTERN.test(password);
  return {
    hasValidLength,
    hasUpperAndLowerCase,
    hasDigit,
    hasSpecialChar,
    isValid: hasValidLength && hasUpperAndLowerCase && hasDigit && hasSpecialChar,
  };
}
